import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ProjectList from "./components/ProjectList";
import ProjectPage from "./components/ProjectPage";
import Login from "./components/Login";
import RequireAuth from "./components/RequireAuth";
import { Button } from "./components/ui/button";
import GlobalSettings from "./components/GlobalSettings";
import TasksOverview from "./components/TasksOverview";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <>
                  <Header />
                  <main className="container mx-auto px-4 py-6">
                    <h1 className="text-2xl font-bold mb-6 text-left">
                      Список проектов
                    </h1>
                    <ProjectList />
                  </main>
                </>
              </RequireAuth>
            }
          />
          <Route
            path="/project/:id"
            element={
              <RequireAuth>
                <>
                  <Header />
                  <main className="container mx-auto px-4 py-6">
                    <ProjectPage />
                  </main>
                </>
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

function Header() {
  const location = useLocation();
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    window.location.href = "/login";
  };

  return (
    <header className="bg-primary text-white py-3 px-4">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-xl font-bold">Behavioral Factor Studio</h1>
        <div className="flex flex-wrap items-center justify-end gap-3">
          {location.pathname === "/" && <TasksOverview />}
          <GlobalSettings />
          {process.env.REACT_APP_VERSION && <span className="text-xs text-white/70" title={`Сборка ${process.env.REACT_APP_REVISION || ""}`}>v{process.env.REACT_APP_VERSION}</span>}
          <span>{localStorage.getItem("username") || "Admin"}</span>
          <Button 
            variant="secondary" 
            size="sm" 
            onClick={handleLogout}
            className="text-primary"
          >
            Выход
          </Button>
        </div>
      </div>
    </header>
  );
}

export default App;
